import { useState } from "react";
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import DateRange from '../selectComponents/DateRange';
import DateFilter from '../selectComponents/DateFilter';
import HourFilter from '../selectComponents/HourFilter';
import DayofweekFilter from '../selectComponents/DayofweekFilter';
import MoreOptions from '../selectComponents/MoreOptions';

export default function BintempsOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton } = props;
  const [ binsizeError, setBinsizeError ] = useState(false);

  const handleBinsizeChange = (event) => {
    let newbin = event.target.value ? event.target.value : "";
    newbin = (newbin !== "" && !isNaN(newbin)) ? parseInt(newbin, 10) : "";
    setUserParams({ ...userParams, binsize:newbin});
    const binsizeProblem = newbin === "" || newbin < 1 || newbin > 10; //true is error
    setBinsizeError(binsizeProblem);
    setDisableGoButton(binsizeProblem);
  }

  return (
    <>
      <DateRange 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <DateFilter
        userParams={userParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <HourFilter 
        userParams={userParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
        <DayofweekFilter 
          userParams={userParams}
          setUserParams={setUserParams}
        />
        <TextField
          name="binsize"
          placeholder="degrees F"
          label="Bin size (degF)"
          value={userParams.binsize}
          onChange={handleBinsizeChange}
          sx={{ width: '16ch' }}
          style={{marginTop:"9px"}}
          error={binsizeError}
        /> 
      </Stack>

      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <MoreOptions
          userParams={userParams}
          setUserParams={setUserParams}
        />

      </Stack>
    </>
  )
}

/* was after MoreOptions block
  import OutputType from '../OutputType';
        <OutputType
          userParams={userParams}
          setUserParams={setUserParams}
        />
*/